import { startCase } from 'lodash-es';
import { BygrModule } from '@/types';

export const showModules = (v: BygrModule) => {
    const out: string[] = [];

    Object.keys(BygrModule).forEach((bm) => {
        if (BygrModule[bm] & v) {
            out.push(startCase(bm));
        }
    });
    return out.join(', ');
};